/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type WorkingModeBlockedItemReasonCode =
  (typeof WorkingModeBlockedItemReasonCode)[keyof typeof WorkingModeBlockedItemReasonCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkingModeBlockedItemReasonCode = {
  VERSION_NOT_EDITABLE: 'VERSION_NOT_EDITABLE',
  EVENT_KIND_UNAVAILABLE: 'EVENT_KIND_UNAVAILABLE',
  FEATURE_DISABLED: 'FEATURE_DISABLED',
  NOT_AUTHOR: 'NOT_AUTHOR',
  APPLY_IN_PROGRESS: 'APPLY_IN_PROGRESS',
} as const;
